import http from '@services/http';
import { Users } from './interfaces';

export const fetchFollowed = () => {
  return http.get<Users.FetchFollowedTopics.Response>(`/users/topics`);
};